import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPixelEvent } from 'utils/metaPixel';

function MetaPixelTracker() {
  const location = useLocation();
  const isFirstRoute = useRef(true)

  useEffect(() => {
    // The initial PageView already fires in index.html.
    if (isFirstRoute.current) {
      isFirstRoute.current = false
      return
    }
    trackPixelEvent('PageView');
  }, [location]);

  return null;
}

export default MetaPixelTracker;
